var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0704 3.70263L7.99935 7.8529L13.9283 3.70263C13.818 3.48462 13.5913 3.33333 13.3327 3.33333H2.66602C2.40737 3.33333 2.18065 3.48462 2.0704 3.70263ZM13.9993 5.28044L8.38166 9.21282C8.15211 9.3735 7.84659 9.3735 7.61704 9.21282L1.99935 5.28044V12C1.99935 12.3651 2.30087 12.6667 2.66602 12.6667H13.3327C13.6978 12.6667 13.9993 12.3651 13.9993 12V5.28044ZM0.666016 4C0.666016 2.89848 1.56449 2 2.66602 2H13.3327C14.4342 2 15.3327 2.89848 15.3327 4V12C15.3327 13.1015 14.4342 14 13.3327 14H2.66602C1.56449 14 0.666016 13.1015 0.666016 12V4Z",
    fill: "#7965C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.1ba661a8297f6ca8076072d6129685f0.svg";
export { ForwardRef as ReactComponent };